import { render, staticRenderFns } from "./StudentInformationHistory.vue?vue&type=template&id=144d5ff6&scoped=true&lang=pug&"
import script from "./StudentInformationHistory.vue?vue&type=script&lang=ts&"
export * from "./StudentInformationHistory.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInformationHistory.vue?vue&type=style&index=0&id=144d5ff6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d5ff6",
  null
  
)

export default component.exports